import React, {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import InfoTracking from '@app/components/common/InfoTracking';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Form, Divider, Button, message, Space, Skeleton, Tag} from 'antd';
import { aplicarCorreccion, obtenerHistorial } from '../../../../apis/CorreccionAcumuladosApi';
import FormCorreccion from './form'
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  
    {
        href: '',
        title: <>
            <HomeOutlined />
            <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Nómina</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Corrección de Acumulados Mensuales</span>
            </>
        ),
    }
];

const CorreccionAcumuladosMensual = () => {
    const [ form ] = Form.useForm()
    const [items, setItems] = useState([]);
    const [disabledForm, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const columns = [
        {
            title: 'Empleado',
            dataIndex: 'empleado_nombre',
            key: 'empleado_nombre',
            sorter: (a, b) => a.empleado_nombre.localeCompare(b.empleado_nombre),
            render: (item, object) => (
                <>
                    <InfoTracking entity={'HistorialCorreccionesAcumulados'} entityId={object.id}/>
                    <span>{item}</span>
                </>
            )
        },
        {
            title: 'Año',
            dataIndex: 'anio',
            key: 'anio',
            sorter: (a, b) => a.anio - b.anio,
        },
        {
            title: 'Mes',
            dataIndex: 'mes',
            key: 'mes',
            sorter: (a, b) => a.mes - b.mes,
            render: (mes) => {
                const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                return meses[mes - 1] || mes;
            }
        },
        {
            title: 'Concepto',
            dataIndex: 'concepto_nombre',
            key: 'concepto_nombre',
        },
        {
            title: 'Monto',
            dataIndex: 'monto',
            key: 'monto',
            render: (value) => value !== null ? `$${parseFloat(value).toFixed(2)}` : '-'
        },
        {
            title: 'Exento',
            dataIndex: 'exento',
            key: 'exento',
            render: (value) => value !== null ? `$${parseFloat(value).toFixed(2)}` : '-'
        },
        {
            title: 'Días',
            dataIndex: 'dias',
            key: 'dias',
            render: (value) => value !== null ? value : '-'
        },
        {
            title: 'Horas',
            dataIndex: 'horas',
            key: 'horas',
            render: (value) => value !== null ? value : '-'
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo_correccion',
            key: 'tipo_correccion',
            render: (tipo) => <Tag color="blue">{tipo}</Tag>
        },
        {
            title: 'Referencia',
            dataIndex: 'referencia',
            key: 'referencia',
            render: (value) => value || '-'
        }
    ];

    const bodyRef = React.createRef();

    useEffect(() => {
        (async () => {
            await refreshHistorial();
        })();
    }, []);

    const handleOk = async ({concepto}) => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        
        // Validar que al menos un campo de corrección tenga valor diferente de 0
        const tieneMonto = fields.monto && fields.monto !== 0;
        const tieneExento = fields.exento && fields.exento !== 0;
        const tieneDias = fields.dias && fields.dias !== 0;
        const tieneHoras = fields.horas && fields.horas !== 0;

        if (!tieneMonto && !tieneExento && !tieneDias && !tieneHoras) {
            message.error('Debe proporcionar al menos un campo de corrección (monto, exento, dias o horas) con un valor diferente de 0');
            return;
        }

        const payload = {
            empleado_id: fields.empleado_id,
            anio: fields.anio,
            mes: fields.mes,
            concepto_id: fields.concepto_id,
            clave_concepto: concepto.clave,
            monto: tieneMonto ? fields.monto : null,
            exento: tieneExento ? fields.exento : null,
            dias: tieneDias ? fields.dias : null,
            horas: tieneHoras ? fields.horas : null,
            referencia: fields.referencia || null,
            tipo_correccion: 'Mensual'
        }

        setLoading(true);
        const response = await aplicarCorreccion(payload);
        setLoading(false);

        if(response.ok){
            message.success('¡Corrección aplicada exitosamente!');
            await resetBody();
            await refreshHistorial();
        } else {
            message.error(response.message || 'Error al aplicar la corrección');
        }
    }

    const resetBody = async ()=>{
        form.resetFields();
    }

    const refreshHistorial = async ()=> {
        setLoading(true);
        const response = await obtenerHistorial();
        if(response.ok){
            let items = response.payload;
            setItems(items);
        }
        setLoading(false);
    }

    return <PageApp 
        routes={routes}
        title={'Corrección de Acumulados Mensuales'}>
        <>
            <FormCorreccion ref={bodyRef} onOk={handleOk} form={form} disabledForm={disabledForm}/>
            <Divider/>
        </>

        {
            loading ?
            <Skeleton loading={loading}/>:
            <>
                {
                    items.length === 0 ? <Empty description="No hay correcciones registradas" />:
                    <Table 
                        dataSource={items} 
                        columns={columns}
                        rowKey="id"
                        pagination={{ pageSize: 10 }}
                        scroll={{ x: 'max-content' }}
                    />
                }
            </>
        }
    </PageApp>
}   

export default CorreccionAcumuladosMensual;
